import { render, staticRenderFns } from "./FormTagsNativeInput.vue?vue&type=template&id=491a7b44&"
import script from "./FormTagsNativeInput.vue?vue&type=script&lang=js&"
export * from "./FormTagsNativeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports